"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const ArticleFormValidator_1 = require("../ArticleFormValidator");
const EvenOddValidatorKeys_1 = require("../EvenOddValidatorKeys");
class KetteFormValidator {
    static innenhoehe(options) {
        return this.mmInchLaengenValidator(options);
    }
    static aussenhoehe(options) {
        return this.mmInchLaengenValidator(options);
    }
    static aussenbreite(options) {
        return this.mmInchLaengenValidator(options);
    }
    static innenbreite(options) {
        return this.mmInchLaengenValidator(options);
    }
    static teilung(options) {
        return this.mmInchLaengenValidator(options);
    }
    static biegeradius(options) {
        return this.mmInchLaengenValidator(options);
    }
    static verfahrweg(options) {
        return this.mmFtLaengenValidator(options);
    }
    static laenge(options) {
        return this.mmFtLaengenValidator(options);
    }
    static effektivelaenge(options) {
        return this.mmFtLaengenValidator(options);
    }
    static effektivelaengewithAE(options) {
        return this.mmFtLaengenValidator(options);
    }
    static versatz(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL_ABSOLUTE_VALUE,
            thresholdMin: -10000000,
            thresholdMax: 10000000,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL_ABSOLUTE_VALUE,
            thresholdMin: -32808.4,
            thresholdMax: 32808.4,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityRangeValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static gewicht(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.001,
        });
        const metricUnit = echain_shared_quantities_1.WeightPerLengthUnits.kg_m;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 3,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.001,
        });
        const imperialUnit = echain_shared_quantities_1.WeightPerLengthUnits.lbs_ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static gliederAnzahl(options) {
        return ArticleFormValidator_1.ArticleFormValidator.anzahl(options);
    }
    static numberOddEven(options) {
        const errorKey = options.type === 'even'
            ? EvenOddValidatorKeys_1.EvenOddValidatorKeys.DISALLOWED_ODD_NUMBER
            : EvenOddValidatorKeys_1.EvenOddValidatorKeys.DISALLOWED_EVEN_NUMBER;
        return echain_shared_form_validation_1.formValidatorDecoratorService.extendToObservableValidator((input) => {
            const controlValue = input.value;
            const validation = echain_shared_validation_1.Validation.empty();
            if (controlValue != null) {
                const expectedRemainder = options.type === 'even' ? 0 : 1;
                // eslint-disable-next-line
                validation.add(echain_shared_validation_1.Validator.truthy(echain_shared_ts_utils_1.NumberUtils.toNumber(controlValue) % 2 === expectedRemainder, errorKey));
            }
            if (validation.hasIssues()) {
                return { OddEven: validation.getIssues()[0] };
            }
            return null;
        }, {
            errorKeys: ['OddEven'],
            errorMessage: options.errorMessage ? options.errorMessage : () => errorKey,
        });
    }
    static mmInchLaengenValidator(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0.01,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0.01,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static mmFtLaengenValidator(options) {
        const defaultThreshold = 0.01;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: options.threshold || defaultThreshold,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: options.threshold || defaultThreshold,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
}
exports.KetteFormValidator = KetteFormValidator;
//# sourceMappingURL=KetteFormValidator.js.map